import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const WorkspaceContext = createContext();
const API = process.env.REACT_APP_BACKEND_URL + '/api';

export function WorkspaceProvider({ children, token }) {
  const [workspaces, setWorkspaces] = useState([]);
  const [activeWorkspace, setActiveWorkspace] = useState(() => {
    try { return JSON.parse(localStorage.getItem('adpulse_workspace') || 'null'); }
    catch { return null; }
  });
  const [clientId, setClientId] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('adpulse_workspace') || 'null');
      return saved?.id || null;
    } catch { return null; }
  });

  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/workspaces`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(r => {
      const ws = r.data?.workspaces || [];
      setWorkspaces(ws);
      
      if (ws.length === 0) {
        // No workspaces — clear everything
        setActiveWorkspace(null);
        setClientId(null);
        localStorage.removeItem('adpulse_workspace');
        return;
      }
      
      // Check if saved workspace belongs to this user's workspaces
      const savedRaw = localStorage.getItem('adpulse_workspace');
      const hasSaved = savedRaw && savedRaw !== 'null';
      if (hasSaved) {
        const saved = JSON.parse(savedRaw);
        const isValid = ws.find(w => w.id === saved?.id);
        if (isValid) {
          setActiveWorkspace(isValid);
          setClientId(isValid.id);
          return;
        }
      }
      // No valid saved workspace — use first
      setActiveWorkspace(ws[0]);
      setClientId(ws[0].id);
      localStorage.setItem('adpulse_workspace', JSON.stringify(ws[0]));
    }).catch(() => {});
  }, [token]);

  const switchWorkspace = useCallback((ws) => {
    setActiveWorkspace(ws);
    setClientId(ws?.id || null);
    localStorage.setItem('adpulse_workspace', JSON.stringify(ws));
  }, []);

  return (
    <WorkspaceContext.Provider value={{ workspaces, activeWorkspace, switchWorkspace, clientId }}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export function useWorkspace() {
  return useContext(WorkspaceContext);
}
